import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import useClientSession from 'hooks/clientSession'
import { WordpressContent } from './styles'

type Props = {
  html: string
  className: string
  navigationParams: Record<string, any>
}
export default ({
  className,
  html,
  navigationParams,
}: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  if (navigationParams?.disableHeader) {
    useClientSession()
  }

  /* We need to remove side padding from the NFT page. We're doing that by
    adding a dataApp value that has a no-padding style override attached to it.
    And we're only showing that where the 'disableHeader' param exists, which
    is only on the NFT page for now. We can create a more formal param for this
    later if there are more complex use cases.
  */
  const appName = navigationParams?.disableHeader ? 'nft' : ''
  return (
    <NavigationLayout {...(navigationParams || {})} dataApp={appName}>
      <WordpressContent>
        <div
          id='wp-page'
          className={className}
          dangerouslySetInnerHTML={{
            __html: html,
          }}
        />
      </WordpressContent>
    </NavigationLayout>
  )
}
